import { useStore } from 'vuex';
import { reactive, watchEffect, watch } from 'vue';
import mukiConst from '@/js/const.js';
import { ajax200Res } from '@/js/utils';
import __unimport_mukiConst from '@/js/const.js';import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  class: "box-media"
};
var _hoisted_2 = {
  class: "box-media-inner"
};
var _hoisted_3 = {
  key: 0,
  class: "box-countdonw-bar"
};
var _hoisted_4 = {
  class: "box-fav-btn"
};
var _hoisted_5 = {
  class: "box-status-overlay"
};
var _hoisted_6 = {
  class: "box-body"
};
var _hoisted_7 = {
  class: "box-title"
};
var _hoisted_8 = {
  class: "box-infobar"
};
var _hoisted_9 = {
  key: 0,
  class: "box-money box-money-ori"
};
var _hoisted_10 = {
  class: "box-toolbar"
};
var _hoisted_11 = {
  class: "box-price-displayer"
};

var _hoisted_12 = /*#__PURE__*/_createVNode("i", {
  class: "icon-cart"
}, null, -1);

import { Product, Action, Cart, CartItemProcess } from "@/js/services/baseService";
import moment from 'moment';
import "moment-duration-format";
export default {
  expose: [],
  props: {
    cartType: [String],
    // 行動超市ID
    mobileStoreId: [String],
    id: [Number, String],
    specId: [Number, String],
    countDown: [String],
    isCollect: [Boolean, Number, String],
    stock: [Number, String],
    name: [String],
    picSrc: [String],
    oriPrice: [Number, String],
    price: [Number, String],
    points: [Number, String],
    product_price_spec_data: Array,
    // 樣式
    paddingSmall: Boolean,
    hideAddCart: Boolean,
    hideOutOfStockHint: Boolean
  },
  emits: ['update:isCollect', 'toggleFav', 'toggleNotFav', 'addedToCart'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var store = useStore();
    var cData = reactive({
      // 收藏狀態
      isCollect: false,
      // 倒數秒數
      countDown: function () {
        var duration = moment.duration(moment(props.countDown, 'YYYY-MM-DD HH:mm:ss').diff(moment()));
        var seconds = duration.asSeconds() || 0;
        if (seconds < 0) seconds = 0;
        return seconds;
      }()
    });
    watchEffect(function () {
      var isCollect = props.isCollect; // 當傳入值是數字字串

      if ('string' === typeof isCollect) {
        isCollect = parseInt(isCollect) || false;
      }

      cData.isCollect = isCollect;
    });
    watch(function () {
      return cData.isCollect;
    }, function () {
      emit('update:isCollect', cData.isCollect);
    }); // 當前使用的行動超市

    var currentSelectedActionStore = store.getters['cart/getCurrentActionStore'];

    var toggleFav = function toggleFav($event) {
      var apiAddCollect = props.cartType === mukiConst.cartType.ACTION_STORE ? Action.action_add_collect : Product.add_collect;
      apiAddCollect({
        product_id: props.id
      }).then(function (res) {
        ajax200Res(res, function (_ref2) {
          var res = _ref2.res,
              data = _ref2.data,
              msg = _ref2.msg,
              defaultAlert = _ref2.defaultAlert;

          // success
          if (msg) {
            defaultAlert();
          }

          cData.isCollect = true;
          emit('toggleFav', cData.isCollect);
        }, function (_ref3) {
          var res = _ref3.res,
              data = _ref3.data,
              msg = _ref3.msg,
              defaultAlert = _ref3.defaultAlert;
          // fail
          defaultAlert();
        });
      });
    };

    var toggleNotFav = function toggleNotFav($event) {
      var apiRemoveCollect = props.cartType === mukiConst.cartType.ACTION_STORE ? Action.action_remove_collect : Product.remove_collect;
      apiRemoveCollect({
        product_id: props.id
      }).then(function (res) {
        ajax200Res(res, function (_ref4) {
          var res = _ref4.res,
              data = _ref4.data,
              msg = _ref4.msg,
              defaultAlert = _ref4.defaultAlert;

          // success
          if (msg) {
            defaultAlert();
          }

          cData.isCollect = false;
          emit('toggleNotFav', cData.isCollect);
        }, function (_ref5) {
          var res = _ref5.res,
              data = _ref5.data,
              msg = _ref5.msg,
              defaultAlert = _ref5.defaultAlert;
          // fail
          defaultAlert();
        });
      });
    };
    /**
     * 加入購物車
     * 
     * 只有行動超市會用到。線上預購時，不會在產品box出現購物車按紐
     */


    var addCart = function addCart($event) {
      $event.preventDefault();
      $event.stopPropagation();
      var allow = false;
      checkAllow(function () {
        allow = true;
      });
      if (!allow) return;
      CartItemProcess({
        product_id: props.id,
        product_spec_id: props.specId,
        cart_type: props.cartType,
        amount: 1,
        type: 'addition'
      }, currentSelectedActionStore.id, props.mobileStoreId).then(function (res) {
        ajax200Res(res, function (_ref6) {
          var res = _ref6.res,
              data = _ref6.data,
              msg = _ref6.msg,
              defaultAlert = _ref6.defaultAlert;

          // success
          if (msg) {
            defaultAlert();
          }

          emit('addedToCart');
        }, function (_ref7) {
          var res = _ref7.res,
              data = _ref7.data,
              msg = _ref7.msg,
              defaultAlert = _ref7.defaultAlert;

          // fail
          if (msg) {
            defaultAlert();
          }
        });
      });
    };

    function checkAllow(callback) {
      var callback = callback || function () {}; // 被設黑名單


      if (store.state.auth.is_blacklist == mukiConst.blackList.YES) {
        alertCustom("訊息提示", mukiConst.blackList.MESSAGE, function () {});
        return;
      }

      if ('function' == typeof callback) {
        callback();
      }
    }

    return function (_ctx, _cache) {
      var _component_BaseImg = _resolveComponent("BaseImg");

      var _component_CountDownGadge = _resolveComponent("CountDownGadge");

      var _component_FavToggle = _resolveComponent("FavToggle");

      var _component_PriceDisplayer = _resolveComponent("PriceDisplayer");

      return _openBlock(), _createBlock("div", {
        class: ["product-box", [__props.paddingSmall ? 'sty-padding-small' : '']]
      }, [_createVNode("div", _hoisted_1, [_createVNode("div", _hoisted_2, [_createVNode(_component_BaseImg, {
        absFill: "",
        src: __props.picSrc
      }, null, 8, ["src"])]), __props.countDown && (_unref(cData).countDown || _unref(cData).countDown == 0) ? (_openBlock(), _createBlock("div", _hoisted_3, [_createVNode(_component_CountDownGadge, {
        seconds: _unref(cData).countDown
      }, null, 8, ["seconds"])])) : _createCommentVNode("", true), _createVNode("div", _hoisted_4, [_createVNode(_component_FavToggle, {
        isFav: Boolean(_unref(cData).isCollect),
        onClick: _cache[1] || (_cache[1] = function ($event) {
          $event.preventDefault();
          $event.stopPropagation();
        }),
        onToggleFav: _cache[2] || (_cache[2] = function ($event) {
          return toggleFav($event);
        }),
        onToggleNotFav: _cache[3] || (_cache[3] = function ($event) {
          return toggleNotFav($event);
        })
      }, null, 8, ["isFav"])]), _withDirectives(_createVNode("div", _hoisted_5, " 已售完 ", 512), [[_vShow, __props.stock == 0 && !__props.hideOutOfStockHint && __props.cartType !== __unimport_mukiConst.cartType.ACTION_STORE]])]), _createVNode("div", _hoisted_6, [_createVNode("div", _hoisted_7, _toDisplayString(__props.name), 1), _createVNode("div", _hoisted_8, [__props.oriPrice != __props.price || __props.product_price_spec_data ? (_openBlock(), _createBlock("div", _hoisted_9, " $" + _toDisplayString(_ctx.$window._number_format(__props.oriPrice)), 1)) : _createCommentVNode("", true)]), _createVNode("div", _hoisted_10, [_createVNode("div", _hoisted_11, [__props.product_price_spec_data ? (_openBlock(true), _createBlock(_Fragment, {
        key: 0
      }, _renderList(__props.product_price_spec_data, function (price_spec, idx) {
        return _openBlock(), _createBlock(_component_PriceDisplayer, {
          key: idx,
          price: _ctx.$window._number_format(price_spec.price),
          points: _ctx.$window._number_format(price_spec.points)
        }, null, 8, ["price", "points"]);
      }), 128)) : (_openBlock(), _createBlock(_component_PriceDisplayer, {
        key: 1,
        price: _ctx.$window._number_format(__props.price),
        points: _ctx.$window._number_format(__props.points)
      }, null, 8, ["price", "points"]))]), __props.cartType == __unimport_mukiConst.cartType.ACTION_STORE && !__props.hideAddCart ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: "box-tool-btn box-add-cart",
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return addCart($event);
        })
      }, [_hoisted_12])) : _createCommentVNode("", true)])])], 2);
    };
  }
};